import { render, staticRenderFns } from "./wechatWebView.vue?vue&type=template&id=bbc748ee&scoped=true&"
import script from "./wechatWebView.vue?vue&type=script&lang=js&"
export * from "./wechatWebView.vue?vue&type=script&lang=js&"
import style0 from "./wechatWebView.vue?vue&type=style&index=0&id=bbc748ee&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc748ee",
  null
  
)

export default component.exports